import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { FaCog, FaBell } from "react-icons/fa";
import CustomButton from "../../MyComponents/CustomButton/CustomButton";
import LatestRequest from "../../MyComponents/LatestRequest/LatestRequest";
import LatestProperty from "../../MyComponents/LatestProperty/LatestProperty";
import Navbar from "../Navbar/Navbar";
import { assets } from "../../../assets/assets";
import { Bars } from 'react-loader-spinner';
import { useSelector } from "react-redux";
import SearchAndFilterBar from "../../MyComponents/SearchAndFilterBar/SearchAndFilterBar";
import Loader from "../../MyComponents/Loader/Loader";
import { postData } from "../../../services/apiServices";
import toastService from "../../../services/toastService";
import PropertyCard from "../../MyComponents/PropertyCard/PropertyCard";
import ModalComponent from "../../MyComponents/ModalComponent/ModalComponent";
import { useNavigate } from "react-router-dom";
import CustomModal from "../CustomModal/CustomModal";

function Dashboard() {
    const [isLoading, setIsLoading] = useState(false);
    const [latestRequests, setLatestRequests] = useState([]);
    const [latestProperties, setLatestProperties] = useState([]);
    const [featuredProperty, setFeaturedProperty] = useState([])
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [searchKeyword, setSearchKeyword] = useState('');

    const navigate = useNavigate()
    const userInfo = useSelector((state) => state.user.userInfo);
    const [isShowModal, setIsShowModal] = useState(false)

    useEffect(() => {
        getDashboardData()
        getFeaturedData()
    }, [])

    const handleClick = (type) => {
        navigate('/createOffer', { state: { offerType: type } });
    };
    const handleClickRequestCard = (data) => {
        navigate('/request-detail', { state: { data } });

        console.log(data, ">>>A>D>AD>>A>DA>>A>>A>")
    };

    const handleCardClick = (propertyData) => {
        console.log(propertyData?.offerId, "ADF>ADS>")
        setSelectedProperty(propertyData?.offerId);
        setModalOpen(true);
    };


    const handleFilterSubmit = (data) => {
        console.log(data, "tera data idhr ha ya dakh")
    }

    const getDashboardData = async () => {
        setIsLoading(true)
        const data = {
            "verification_token": process.env.REACT_APP_VERIFICATION_TOKEN,
            "userid": userInfo?.id
        };

        try {
            const result = await postData("/getdashboard", data);
            setIsLoading(false)
             setLatestProperties(result?.property_offers)
            setLatestRequests(result?.request_offers)
 

        } catch (error) {
            setIsLoading(false)
            console.log(error, "Error");
        }
    };


    const getFeaturedData = async (apiData) => {
        const data = {
            "page": "1",
            "searchkeyword": apiData ? apiData?.searchKeyword : "",
            "District": apiData ? apiData?.district : "",
            "beds": apiData ? apiData?.beds : "",
            "status": apiData ? apiData?.status : "",
            "price": apiData ? apiData?.price : "",
            "userid": userInfo?.id,
            "expired": "",
            "verification_token": process.env.REACT_APP_VERIFICATION_TOKEN,
        }

        try {
            const result = await postData("/searchproperty", data);
            if (result?.message === "success") {
                setFeaturedProperty(result?.data)
            } else {
                setFeaturedProperty([])

            }


        } catch (error) {
            console.log(error, "Error");
            toastService.showError("Something went wrong")
        }
    };

    const fileterModal = () => {
        setIsShowModal(!isShowModal)
    }

    const submitFilterModal = (data) => {
        console.log(data, "A?A?DF?A??A?")
        getFeaturedData(data)
    }


    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchKeyword(value);

        if (value.length > 2) {
            getFeaturedData({ searchKeyword: value });
        } else {
            getFeaturedData({ searchKeyword: '' });
        }
    };


    const handlePropertyClick = (propertyData) => {
        console.log(propertyData, "?ASD??");
        navigate(`/propertyOfferDetail/${propertyData?.offerId}`); // Navigate to the detail screen
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="dashboard-container">
                <Navbar />
                <div className="render-main-container">
                    <div className="render-main-innerContainer">
                        <div className="title-Container">
                            {/* <SearchAndFilterBar onFilterSubmit={handleFilterSubmit} /> */}
                            <div className="row-div-inputsBtn">
                                <input
                                    type="text"
                                    id="search"
                                    placeholder="Search Offer and Property"
                                    className="input-text"
                                    value={searchKeyword}
                                    onChange={handleSearchChange}
                                    required
                                />

                                <CustomButton style={{ padding: 20 }} onClick={() => { handleClick("Request") }}  >
                                    Create Request
                                </CustomButton>
                                <CustomButton style={{ padding: 20 }} onClick={() => { handleClick("Offer") }} >
                                Create Offer
                                </CustomButton>
                                <CustomButton
                                    style={{ backgroundColor: '#333333', color: 'white', border: '1px solid #000', padding: 20 }}
                                    className="custom-button" onClick={() => fileterModal()} icon={assets.filterImg}>
                                    Filter property
                                </CustomButton>
                            </div>
                        </div>
                        <div className="row-title-container">
                            <h2>Offer Found</h2>
                            {/* <h2>View All</h2> */}

                        </div>

                        <div className="parent-container">
                            {featuredProperty.length === 0 ? (
                                <p>No property found</p>
                            ) : (
                                featuredProperty.map((property, index) => (
                                    <PropertyCard
                                        key={index}
                                        image={property.Pictures}
                                        title={property.PropertyName}
                                        location={property.District}
                                        status={property.PropertyStatus}
                                        construction={property.PropertyStatus}
                                        type={property.PropertyType}
                                        propertyDescripiton={property.Description}
                                        price={property?.Price}
                                        date={property?.CreatedDate}
                                        offerId={property?.id}
                                        NoOfRooms={property?.NumberOfRooms}
                                        Area={property?.Area}
                                        is_fav={property?.is_fav}
                                        is_fav_id={property?.is_fav_id}
                                        handleClick={handleCardClick}
                                    />
                                ))
                            )}
                        </div>

                        <div className="row-title-container">
                            <h2>Latest Request</h2>
                            <h2>View All</h2>

                        </div>
                        <LatestRequest data={latestRequests} onCardClick={handleClickRequestCard} />
                        <div className="row-title-container">
                            <h2>Latest Request</h2>
                            <h2>View All</h2>

                        </div>
                        <div className="parent-container">
                            {latestProperties.map((property, index) => (
                                <LatestProperty
                                    key={index}
                                    image={property.Pictures}
                                    title={property.PropertyName}
                                    location={property.District}
                                    status={property.PropertyStatus}
                                    construction={property.PropertyStatus}
                                    type={property.PropertyType}
                                    propertyDescripiton={property.Description}
                                    price={property?.Price}
                                    date={property?.CreatedDate}
                                    offerId={property?.id}
                                    NoOfRooms={property?.NumberOfRooms}
                                    Area={property?.Area}
                                    handleClick={handlePropertyClick}
                                />
                            ))}
                        </div>
                    </div>
                    <ModalComponent
                        isOpen={isModalOpen}
                        onRequestClose={() => setModalOpen(false)}
                        offerId={selectedProperty}
                    />
                    <CustomModal show={isShowModal} onClose={fileterModal} onSubmit={submitFilterModal} />
                </div>
            </div>
        </>

    );
}

export default Dashboard;
